// import React, { useEffect, useState } from 'react';
// import {
//   View,
//   StyleSheet,
//   StatusBar,
//   Text,
//   Image,
//   ScrollView,
//   TouchableOpacity,
//   ImageBackground,
//   RefreshControl,
//   SafeAreaView,
// } from 'react-native';
// import { Colors, Dim } from '../../../constants/Theme';
// import { Fonts } from '../../../constants/fonts';
// import AntDesign from 'react-native-vector-icons/AntDesign';
// import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
// import Entypo from 'react-native-vector-icons/Entypo';
// import StartGameOverlay from '../../../components/overlays/StartGameOverlay';
// import GradientText from '../../../constants/linearGrad';
// import { LinearTextGradient } from "react-native-text-gradient";
// // import MaskedView from "@react-native-community/masked-view";
// import LinearGradient from 'react-native-linear-gradient';
// import { useSelector, useDispatch } from 'react-redux';
// import { GetMySubscriptionAction } from '../../../redux/actions/subscriptions.actions';
// import { GetAllTeamsAction } from '../../../redux/actions/team.actions';




// const UserDashboard = props => {
//   const dispatch = useDispatch();
//   const operatorTeam = useSelector(state => state.teamReducer.selectedTeam);
//   const user = useSelector(state => state.authReducer.user);
//   const [isVisible, setIsVisible] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(false);
//   const [isAvailable, setIsAvailable] = useState(true);




//   // const GradientText = (props) => {
//   //   return (
//   //     <MaskedView maskElement={<Text {...props} />}>
//   //       <LinearGradient
//   //         colors={["red", "green"]}
//   //         start={{ x: 0, y: 0 }}
//   //         end={{ x: 1, y: 0 }}
//   //       >
//   //         <Text {...props} style={[props.style, { opacity: 0 }]} />
//   //       </LinearGradient>
//   //     </MaskedView>
//   //   );
//   // };


//   const toggleStartGame = () => {
//     setIsVisible(!isVisible);
//   };
//   const drawerToggleHandler = () => {
//     props.navigation.toggleDrawer();

//   };
//   useEffect(() => {
//     //Free Trial
//     if (
//       operatorTeam?.subscriptionType.subscriptionName ===
//       'Free trial(Clock only)' ||
//       operatorTeam?.subscriptionType.subscriptionName ===
//       'Free trial(Clock stats)'
//     ) {
//       if (operatorTeam?.timesUsed > 0) {
//         setIsAvailable(false);
//       } else {
//         setIsAvailable(true);
//       }
//     }
//     //Usage Times
//     if (
//       operatorTeam?.subscriptionType.subscriptionName ===
//       'times allowed(stats)' ||
//       operatorTeam?.subscriptionType.subscriptionName === 'times allowed(only)'
//     ) {
//       if (operatorTeam?.timesUsed === operatorTeam?.timesAllowed) {
//         setIsAvailable(false);
//       } else {
//         setIsAvailable(true);
//       }
//     }
//     //other
//     if (
//       operatorTeam?.subscriptionType.subscriptionName !==
//       'Free trial(Clock only)' &&
//       operatorTeam?.subscriptionType.subscriptionName !==
//       'Free trial(Clock stats)' &&
//       operatorTeam?.subscriptionType.subscriptionName !==
//       'times allowed(stats)' &&
//       operatorTeam?.subscriptionType.subscriptionName !== 'times allowed(only)'
//     ) {
//       if (Number(operatorTeam?.endTime) - Date.now() > 0) {
//         setIsAvailable(true);
//       } else {
//         setIsAvailable(false);
//       }
//     }
//   }, [operatorTeam]);
//   useEffect(() => {
//     if (user) {
//       dispatch(GetMySubscriptionAction({ userId: user._id }, user?.token));
//     }
//     dispatch(GetAllTeamsAction(user?.token));
//   }, [user]);

//   return (
//     <ImageBackground
//       source={require('../../../assets/images/player2.jpg')}
//       style={styles.container}>
//       <View style={{ ...styles.container, backgroundColor: 'rgba(0,0,0,0.8)' }}>
//         <StatusBar backgroundColor={Colors.darkBlue} />

//         <ImageBackground
//           source={require('../../../assets/images/laxHeader.png')}
//           style={{ width: Dim.w, height: Dim.w * 0.45 }}
//         />

//         <View style={styles.iconsView}>
//           <View style={{ width: 10 }} />
//           <View style={{ width: 10 }} />

//           <TouchableOpacity
//             onPress={drawerToggleHandler}
//             style={styles.menuBtn}>
//             <AntDesign name="caretleft" size={15} color={Colors.goldenBrown} />
//           </TouchableOpacity>
//         </View>

//         <Text

//           style={{ ...styles.wlcmTxtone, color: Colors.white }}>
//           KICK IT UP A NOTCH!
//         </Text>
//         {/* <Text>
//         {operatorTeam?.teamId.teamName}
//         </Text> */}

//         <SafeAreaView style={styles.container}>
//       <GradientText colors={['#ED925F', '#CE3B81']} style={styles.wlcmTxt}>
//       {operatorTeam?.teamId.teamName}
//       </GradientText>
//     </SafeAreaView>

//         <View style={{ flexDirection: 'row' }}>
//           <TouchableOpacity
//             onPress={() => props.navigation.navigate('LicenseTeamDetail')}
//             style={styles.btn}>

//             <View style={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
//               <View style={styles.scroll}>
//                 <MaterialCommunityIcons
//                   name="account-group"
//                   size={Dim.h * 0.02}
//                   color={Colors.white}
//                 />
//               </View>

//               <Text style={{ ...styles.txt, marginLeft: 74 }}>Team & Roster</Text>
//             </View>
//             <Entypo
//               name="chevron-right"
//               size={Dim.h * 0.02}
//               color={Colors.white}
//             />
//           </TouchableOpacity>

//           <TouchableOpacity
//             onPress={() => props.navigation.navigate('Opponents')}
//             style={styles.btn}>
//             <View style={{ flexDirection: 'column', alignItems: 'center' }}>
//               <View style={styles.scroll}>
//                 <MaterialCommunityIcons
//                   name="account-group"
//                   size={Dim.h * 0.02}
//                   color={Colors.white}
//                 />
//               </View>
//               <Text style={styles.txt}>Opponents & Roster</Text>
//             </View>
//             <Entypo
//               name="chevron-right"
//               size={Dim.h * 0.02}
//               color={Colors.white}
//             />
//           </TouchableOpacity>
//         </View>
        // <TouchableOpacity
        //   onPress={() => props.navigation.navigate('GameLog')}
        //   style={{ ...styles.btn, marginLeft: -10 }}>
        //   <View style={{ flexDirection: 'column', alignItems: 'center' }}>
        //     <View style={styles.scroll2}>
        //       <MaterialCommunityIcons
        //         name="history"
        //         size={Dim.h * 0.02}
        //         color={Colors.white}
        //       />
        //     </View>
        //     <Text style={styles.txt}>Schedule & Results</Text>
        //   </View>
//           <Entypo
//             name="chevron-right"
//             size={Dim.h * 0.02}
//             color={Colors.white}
//           />
//         </TouchableOpacity>
//         {/* <Image
//           source={require('../../../assets/icons/dashboard.png')}
//           style={styles.logo}
//         /> */}
//         {loading ? (
//           <View style={{ marginTop: 10 }}>
//             <ActivityIndicator color={Colors.darkBlue} size="large" />
//           </View>
//         ) : error === true ? (
//           <View style={styles.unavailableBtn}>
//             <Text style={styles.unavailableBtnTxt}>CONNECTION FAILED</Text>
//           </View>
//         ) : (
//           <>
//             {isAvailable === true ? (
//               <>

//                 <TouchableOpacity

//                   onPress={toggleStartGame}
//                   style={styles.startGameBtn}>

//                   <Text style={styles.startGameTxt}>START GAME</Text>
//                 </TouchableOpacity>
//               </>
//             ) : (
//               <>
//                 <View style={styles.unavailableBtn}>
//                   <Text style={styles.unavailableBtnTxt}>
//                     SUBSCRIPTION EXPIRED
//                   </Text>
//                 </View>
//               </>
//             )}
//           </>
//         )}

//         <StartGameOverlay
//           visible={isVisible}
//           setIsVisible={setIsVisible}
//           onBackdropPress={() => toggleStartGame(false)}
//           navigation={props.navigation}
//           licenseTeamData={operatorTeam}
//         />
//       </View>
//     </ImageBackground>
//   );
// };

// export default UserDashboard;

// const styles = StyleSheet.create({
//   container: {
//     flex: 1,

//   },
//   iconsView: {
//     width: Dim.w,
//     alignItems: 'center',
//     flexDirection: 'row',
//     justifyContent: 'space-between',
//     marginBottom: Dim.h * 0.05,
//   },
//   menuBtn: {
//     width: 25,
//     height: 65,
//     backgroundColor: Colors.darkBlue,
//     alignItems: 'center',
//     justifyContent: 'center',
//     borderTopLeftRadius: 5,
//     borderBottomLeftRadius: 5,
//   },
//   logo: {
//     width: Dim.w * 0.5,
//     height: Dim.w * 0.26,
//     alignSelf: 'center',
//     marginTop: 20,
//   },
//   wlcmTxt: {
//     fontSize: 27,
//     color: Colors.goldenBrown,
//     fontFamily: Fonts.heading,
//     alignSelf: 'center',
//     textAlign: 'center',
//      marginTop: -12,
//     marginBottom: 25,
//     lineHeight: 39,
//   },

//   wlcmTxtone: {
//     fontSize: 25,
//     color: Colors.goldenBrown,
//     fontFamily: Fonts.heading,
//     alignSelf: 'center',
//     textAlign: 'center',
//     marginTop: -30,
//     marginBottom: 30,
//     lineHeight: 26,
//   },

//   rowView: {
//     width: Dim.w * 0.93,
//     alignSelf: 'center',
//     flexDirection: 'row',
//     alignItems: 'center',
//     justifyContent: 'space-between',
//     marginBottom: Dim.h * 0.05,
//   },
//   subsContainer: {
//     width: Dim.w * 0.45,
//     borderRadius: 10,
//     backgroundColor: Colors.whiteO,
//     padding: 10,
//     paddingVertical: 15,
//   },
//   subTxt: {
//     fontSize: 12,
//     color: Colors.darkBlue,
//     fontFamily: Fonts.medium,
//     alignSelf: 'center',
//     borderBottomWidth: 0.5,
//     borderBottomColor: Colors.blue,
//     width: Dim.w * 0.4,
//     textAlign: 'center',
//     paddingBottom: 5,
//   },
//   number: {
//     fontSize: 30,
//     color: Colors.darkBlue,
//     alignSelf: 'center',
//     marginTop: 5,
//     fontFamily: Fonts.regular,
//   },
//   startBtn: {
//     width: Dim.w * 0.72,
//     height: 50,
//     alignSelf: 'center',
//     flexDirection: 'row',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     borderRadius: 15,
//     marginBottom: 10,
//     paddingLeft: 15,
//     paddingRight: 10,
//     backgroundColor: Colors.darkBlue,
//     borderColor: Colors.white,
//     borderWidth: 1,
//   },
//   btnTxt: {
//     color: Colors.white,
//     fontSize: 22,
//     fontFamily: Fonts.heading,
//   },
//   unavailableBtn: {
//     borderRadius: 20,
//     backgroundColor: Colors.darkgrey,
//     alignSelf: 'center',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: 60,
//     borderWidth: 1,
//     borderColor: Colors.white,
//     paddingHorizontal: 20,
//     marginBottom: 20,
//   },
//   unavailableBtnTxt: {
//     color: Colors.whiteO,
//     fontSize: 30,
//     fontFamily: Fonts.heading,
//   },




//   header: {
//     width: Dim.w * 0.65,
//     height: Dim.w * 0.51,
//     paddingTop: Dim.w * 0.05,
//   },
//   icon: {
//     alignSelf: 'center',
//     justifyContent: 'center',
//     width: Dim.w * 0.3,
//     height: Dim.w * 0.265,

//   },
//   racketLogo: {
//     position: 'absolute',
//     bottom: 0,
//     width: Dim.w * 0.65,
//     height: Dim.h * 0.38,
//   },
//   wlcmTeamName: {
//     color: Colors.goldenBrown,
//     fontSize: Dim.h * 0.03,
//     alignSelf: 'center',
//     fontFamily: Fonts.heading,
//     lineHeight: Dim.h * 0.03,
//     textAlign: 'center',
//   },
//   userIcon: {
//     borderRadius: 100,
//     height: 60,
//     width: 60,
//     borderWidth: 3,
//     borderColor: Colors.white,
//     marginRight: 10,
//     justifyContent: 'center',
//     alignItems: 'center',
//   },
//   btn: {
//     width: Dim.w * 0.38,
//     flexDirection: 'column',
//     alignItems: 'center',
//     alignSelf: 'center',
//     borderWidth: 1,
//     marginBottom: 22,
//     marginLeft: 29,
//     // backgroundColor: Colors.blue,
//     borderColor: Colors.goldenBrown,
//     borderRadius: 10,
//     paddingVertical: 12,
//     paddingHorizontal: 5,
//     justifyContent: 'space-between',
//   },
//   subIcon: {
//     borderWidth: 1,
//     borderRadius: 1,
//     borderRadius: 100,
//     alignItems: 'center',
//     justifyContent: 'center',
//     padding: Dim.h * 0.01,
//     paddingLeft: Dim.h * 0.01,
//   },
//   txt: {
//     fontSize: Dim.h * 0.016,
//     color: Colors.white,
//     marginLeft: 50,
//     fontFamily: Fonts.heading,
//     width: Dim.w * 0.45,

//     // backgroundColor: 'pink',
//   },
//   scroll: {
//     borderRadius: 100,
//     borderWidth: 1,
//     borderColor: Colors.goldenBrown,
//     padding: Dim.w * 0.01,
//     paddingVertical: Dim.w * 0.01,
//   },
//   scroll2: {
//     borderRadius: 100,
//     borderWidth: 1,
//     borderColor: Colors.goldenBrown,
//     padding: Dim.w * 0.01,
//     paddingVertical: Dim.w * 0.01,
//   },
//   startGameBtn: {
//     width: Dim.w * 0.4,
//     paddingVertical: Dim.h * 0.01,
//     backgroundColor: Colors.goldenBrown,
//     borderWidth: 2,
//     borderColor: Colors.goldenBrown,
//     borderRadius: 100,
//     alignSelf: 'center',
//     alignItems: 'center',
//     justifyContent: 'center',
//     marginTop: 10,
//     marginBottom: 30,
//     shadowColor: '#000',
//     shadowOffset: {
//       width: 0,
//       height: 12,
//     },
//     shadowOpacity: 0.58,
//     shadowRadius: 16.0,
//     elevation: 24,
//   },
//   startGameTxt: {
//     color: Colors.white,
//     paddingBottom: 4,
//     fontSize: Dim.h * 0.02,
//     fontFamily: Fonts.heading,
//   },
//   unavailableBtn: {
//     width: Dim.w * 0.5,
//     paddingVertical: Dim.h * 0.01,
//     backgroundColor: Colors.darkgrey,
//     borderWidth: 2,
//     borderColor: Colors.white,
//     borderRadius: 100,
//     alignSelf: 'center',
//     alignItems: 'center',
//     justifyContent: 'center',
//     marginTop: 10,
//     marginBottom: 30,
//   },
//   unavailableBtnTxt: {
//     color: Colors.whiteO,
//     fontSize: 20,
//     fontFamily: Fonts.heading,
//   },
//   logOutView: {
//     flexDirection: 'row',
//     alignItems: 'center',
//     justifyContent: 'center',
//     marginBottom: 15,
//     marginLeft: -5,
//   },
//   logOutTxt: {
//     fontSize: Dim.h * 0.02,
//     color: Colors.darkBlue,
//     fontFamily: Fonts.medium,
//   },
 
 
// });

import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { GetMySubscriptionAction } from '../../../redux/actions/subscriptionAction.js';
import { GetAllTeamsAction } from '../../../redux/actions/teamActions.js';

import ScheduleIcon from '@mui/icons-material/Schedule';
import GroupsIcon from '@mui/icons-material/Groups';

import { useHistory } from 'react-router-dom';
import mainImg from '../assets/dashboard.png';
import headerImg from '../assets/laxHeader.png'
import "./dashboard.css";

const UserDashboard = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();


  const operatorTeam = useSelector(state => state.team.selectedTeam);
  const user = useSelector(state => state.auth.user);
  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [isAvailable, setIsAvailable] = useState(true);

  useEffect(() => {
    if (operatorTeam?.subscriptionType.subscriptionName === 'Free trial(Clock only)' || operatorTeam?.subscriptionType.subscriptionName === 'Free trial(Clock stats)') {
      setIsAvailable(operatorTeam?.timesUsed <= 0);
    } else if (operatorTeam?.subscriptionType.subscriptionName === 'times allowed(stats)' || operatorTeam?.subscriptionType.subscriptionName === 'times allowed(only)') {
      setIsAvailable(operatorTeam?.timesUsed < operatorTeam?.timesAllowed);
    } else {
      setIsAvailable(Number(operatorTeam?.endTime) - Date.now() > 0);
    }
  }, [operatorTeam]);

  useEffect(() => {
    if (user) {
      dispatch(GetMySubscriptionAction({ userId: user._id }, user?.token));
    }
    dispatch(GetAllTeamsAction(user?.token));
  }, [user, dispatch]);

  const handleGameLog = () => {
    history.push('/gamelog');
  };

  const handleTeamsAndRoster = () => {
    history.push('/myteam');
  };

  return (
    <div className="dashboardContainer">
      {/* Sidebar */}
      <div className='sidebarDashboard'>
      <div className='imageBoxHeader'>
          <img src={headerImg} className="headerImageTop" alt="Dashboard Header" />
        </div>
        <p className="handwritten" style = {{color: '#0a2e5e'}}> Welcome</p>
        <p className='userTeamNameSide'> {operatorTeam?.teamId?.teamName}</p>

        <ul>
          <li onClick={handleGameLog} style={{ display: 'flex', alignItems: 'center', fontWeight: '700' }}>
           <ScheduleIcon style={{ marginRight: '6px' }} />
           Game Schedule & Results</li>

        </ul>
        <ul>
          <li onClick={handleTeamsAndRoster} style={{ display: 'flex', alignItems: 'center', fontWeight: '700' }}>
           <GroupsIcon style={{ marginRight: '6px' }} />
           Teams and Roster</li>

        </ul>
      </div>

      {/* Main Content */}
      <div className="mainContent">
        {/* Sidebar Toggle Button */}
       
        <p className='userTeamNameMain'> {operatorTeam?.teamId?.teamName}</p>
        <div className='imageBoxMain'>
          <img src={mainImg} className="headerImage" alt="Dashboard Header" />
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;


